import type { FaireProductEntity } from "../../entity_types/product";

export const p_5rfkqxgsw5: FaireProductEntity = {
  token: "p_5rfkqxgsw5",
  type: "product",
  name: "HERSHEY'S Milk Chocolate Racer Building Set",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/e94dd75ce1a04e68e0ec803c46633925a39ff0b3bac7201ee7077be90b6e6230.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7fbceb4b64f35ddaaa221f60ee323f68f29f3693ee68ccffea119495226aca79.jpeg",
    "https://cdn.faire.com/fastly/93194b57323d28636430c1c32cbcf4c519a9b1449970524bc61da99b565abd81.jpeg",
    "https://cdn.faire.com/fastly/69ce1e13bcc5bd955c754d7959d96bd35f1bd56d031a015fa236d47d76f0545a.jpeg",
    "https://cdn.faire.com/fastly/44589d5696ae85bdc6ca6377268e083621793f5b23a4fdfe3d36dbce10f19a0a.jpeg",
    "https://cdn.faire.com/fastly/6b12abff1e9d01b17360ea225e80af03904b7f894aabe48add9594a09844336c.jpeg",
    "https://cdn.faire.com/fastly/ce7d5e819cc31bb64afaf0742f82ab7911f66c45ebae46eb400192f73dce65b5.jpeg",
  ],
  priceDollars: 5.51,
  description:
    "The HERSHEY’S Milk Chocolate Racer turns the iconic chocolate bar into a brick-built candy car with smooth-rolling wheels and printed Hershey’s details. Designed with a rich maroon finish and a custom chocolate bar spoiler, this set is quick to build and fun to collect. Whether you're racing it across your desk or adding it to your shelf of brick-built novelties, this sweet little ride is one of five candy cars in the collectible Brickcraft series.",
  tags: [],
  msrpDollars: 11.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:55.545Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
